module.exports = __webpack_public_path__ + "img/gamesdk22.a914b0e.png";